import { createContext } from "react";

const profileContext = createContext()
const tierContext = createContext()

export  {profileContext, tierContext}